<template>
  <div id="form" class="form">
    <div class="grid-container" v-if="status == 1">
      <h2 class="form__title text-center">Para mais protecção fale connosco.</h2>
      <h3 class="text-center form__subtitle">Preencha os seus dados e nós contactamos:</h3>
      <div class="grid-x grid-padding-x align-center">
        <div class="small-12 cell">
          <div class="form-group">
            <label for="name">Nome*</label>
            <input type="text" name="name" id="name" placeholder="Primeiro e último nome" class="form__input" v-model="form.CustomerName" v-validate="'required'" data-vv-as="Nome">
            <span class="error" v-if="errors.first('name')">{{ errors.first('name') }}</span>
          </div>
           <div class="form-group">
            <label for="name">Província*</label>
            <select name="state" id="state" class="form__input form__input--select" v-model="form.CustomerState" v-validate="'excluded:0'" data-vv-as="Província">
              <option value="0" selected disabled>Província</option>
              <option v-for="(state, index) in states" :key="index" :value="state">{{state}}</option>
            </select>
            <span class="error" v-if="errors.first('state')">{{ errors.first('state') }}</span>
          </div>
          <div class="form-group">
            <label for="email">Email*</label>
            <input type="text" name="email" id="email" placeholder="email@dominio.com" class="form__input" v-model="form.CustomerEmail" v-validate="'required|email'" data-vv-as="Email">
            <span class="error" v-if="errors.first('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="form-group">
            <label for="phone">Telemóvel*</label>
            <input type="text" name="phone" id="phone" placeholder="ex: 810000000" class="form__input" v-model="form.CustomerPhone" v-validate="'required|min:9|max:9|validphone:8'" data-vv-as="Telemóvel" v-mask="'#########'">
            <span class="error" v-if="errors.first('phone')">{{ errors.first('phone') }}</span>
          </div>
        </div>
        <div class="small-12 cell">
          <div class="rgpd">
            <h3 class="rgpd__text"><strong>Por que precisamos dos seus dados?</strong></h3>
            <p class="rgpd__text">
              Os seus dados pessoais serão tratados para posterior contacto, com a finalidade de esclarecer as suas dúvidas sobre o Seguro Automóvel Fidelidade Ímpar, envio de simulação e para fazer o acompanhamento comercial da mesma, com fundamento no desenvolvimento de diligências pré-contratuais e contratuais, a pedido do titular e no interesse legítimo de desenvolvimento da actividade comercial da Seguradora. O “desenvolvimento da actividade comercial da Seguradora”, deve ser entendido como sendo restrito ao produto Fidelidade Ímpar que foi objecto do pedido de contacto.
            <p>
            <p class="rgpd__text">
              <a class="rgpd__link" href="https://www.fidelidade.co.ao/Documents/politica-de-protecao-de-dados-pessoais-fidelidade-angola.pdf" target="_blank">Consulte aqui, informação mais detalhada sobre protecção e tratamento dos seus dados pela Fidelidade.</a>
            </p>
            <div class="text-center">
              <button type="button" class="btn btn__text form__btn" @click="submitForm" :disabled="btnDisable">Quero ser contactado</button>
            </div>
            <span class="backenderror" style="display:block;" v-for="(error, index) in consoleErrors" :key="index">{{ error[0] }}<br></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Page -->
    <div class="grid-container" v-if="status == 2">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Obrigado pela sua confiança.</h4>
              <img src="../../assets/icon-thanks.svg" alt="Obrigado" width="60" height="60" class="form-success__img"  style="margin: 20px 0"/>
              <p class="form-success__text">
                <strong>Irá brevemente ser contactado pela Fidelidade Ímpar.</strong>
            </p>
        </div>
      </div>
    </div>

    <!-- Already Submited Page -->
    <div class="grid-container" v-if="status == 3">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Obrigado pela sua confiança.</h4>
          <img src="../../assets/icon-thanks.svg" alt="Obrigado" width="60" height="60" class="form-success__img" style="margin: 20px 0" />
          <p class="form-success__text">
            <strong>Irá brevemente ser contactado pela Fidelidade.</strong>
          </p>
        </div>
      </div>
    </div>

    <!-- Error processing Lead -->
    <div class="grid-container" v-if="status == 4">
      <div class="grid-x grid-padding-x align-center">
        <div class="small-10 large-8 cell text-center">
          <h4 class="form-success__title">Ups.</h4>
          <img src="../../assets/icon-thanks.svg" alt="Obrigado" width="60" height="60" class="form-success__img" style="margin: 20px 0" />
          <p class="form-success__text">
            <strong>Irá brevemente ser contactado pela Fidelidade.</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import pt from 'vee-validate/dist/locale/pt_PT'
import VeeValidate, { Validator } from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import axios from 'axios'
import validateNAME from '../LeadStore/validations/name'
import validatePHONE from '../LeadStore/validations/phone'

Vue.prototype.$http = axios

Vue.use(VeeValidate)
Vue.use(VueTheMask)

Validator.localize('pt', pt)

function getParameterByName (name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export default {
  data () {
    return {
      status: 1,
      consoleErrors: null,
      btnDisable: false,
      states: ["Cabo Delgado", "Gaza", "Inhambane", "Manica", "Maputo (cidade)", "Maputo", "Nampula", "Niassa", "Sofala", "Tete", "Zambézia"],
      form: {
        CustomerName: null,
        CustomerEmail: null,
        CustomerPhone: null,
        CustomerState: 0,
        utm_campaign: null,
        utm_source: null,
        utm_medium: null,
        utm_content: null,
        utm_term: null,
      }
    }
  },
  created () {
    this.$validator.extend('validname', validateNAME)
    this.$validator.extend('validphone', validatePHONE)
    this.form.utm_campaign = getParameterByName('utm_campaign')
    this.form.utm_source = getParameterByName('utm_source')
    this.form.utm_medium = getParameterByName('utm_medium')
    this.form.utm_content = getParameterByName('utm_content')
    this.form.utm_term = getParameterByName('utm_term')
  },
  methods: {
    submitForm: function() {
      var _this = this
      this.btnDisable = true
      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.$http
            .post('https://fidelidade.caetsudigital.com/api/custom/store-form-json',
              { category: 'auto-performance-mz', content: _this.form }
            )
            .then((response) => {
              console.log(response)
              if (response.data.nif) {
                _this.status = 3
              } else {
                if (response.data.status) {
                  window.dataLayer.push({ event: 'ajaxLSSuccess' })
                  _this.status = 2 // Show Success
                } else {
                  _this.status = 4 // Show Error
                }
              }
            })
            .catch(error => {
              console.log(error)
              _this.consoleErrors = error.response.data.errors
            })
        }
      })
      this.btnDisable = false
    },
  }
}
</script>
